<ng-template
  #insertDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [origin]="insertDropdownTrigger"
  [positions]="dropdownPositions"
  [rtConnectedOverlayPosition]="['bottomright']"
  (backdropClick)="insertDropdown.open = false"
>
  <rt-redactor-inserts-dropdown
    [emailTemplateInsideTemplate]="emailTemplateInsideTemplate"
    [inserts]="filteredInserts()"
    [dropdownRef]="insertDropdown"
    [canManageCandidates]="canManageCandidates"
    (insertLink)="insertLink($event)"
    (emailTemplateChoose)="emailTemplateChoose.emit($event)"
    (saveAsTemplate)="saveAsTemplate.emit()"
  />
</ng-template>

<rt-button
  #insertDropdownTrigger="rtOverlayOrigin"
  (click)="openDropdown($event, insertDropdown)"
  (mousedown)="saveSelection($event)"
  variant="outline"
  [pressed]="insertDropdown.open"
  [disabled]="disabled()"
  rt-overlay-origin
  class="insert-button"
>
  <rt-icon name="playlist-add" />
  <span>{{ 'app.redactor_inserts.dropdown.heading' | translate }}</span>
</rt-button>
